import "./tabs.css";

export interface ToolTab {
  id: string;
  label: string;
  disabled?: boolean;
}

export interface ToolTabsProps {
  tabs: ToolTab[];
  activeId: string;
  onSelect: (id: string) => void;
  ariaLabel: string;
  /** optionele extra className op de <nav> */
  className?: string;
  /** prefix voor tab-knop id's (default: jari-tool-tab) */
  tabIdPrefix?: string;
  /** prefix voor tabpanel id's in aria-controls (default: jari-tool-panel) */
  panelIdPrefix?: string;
}

export function ToolTabs({
  tabs,
  activeId,
  onSelect,
  ariaLabel,
  className,
  tabIdPrefix = "jari-tool-tab",
  panelIdPrefix = "jari-tool-panel",
}: ToolTabsProps) {
  return (
    <nav
      className={`jari-tool-tabs${className ? ` ${className}` : ""}`}
      role="tablist"
      aria-label={ariaLabel}
    >
      {tabs.map((t) => (
        <button
          key={t.id}
          type="button"
          role="tab"
          id={`${tabIdPrefix}-${t.id}`}
          className={`jari-tool-tab${activeId === t.id ? " is-active" : ""}`}
          aria-selected={activeId === t.id}
          aria-controls={`${panelIdPrefix}-${t.id}`}
          disabled={t.disabled}
          onClick={() => onSelect(t.id)}
        >
          {t.label}
        </button>
      ))}
    </nav>
  );
}
